var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rfi-page-select" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "text-center py-4" },
          [
            _c("b-spinner", { attrs: { small: "" } }),
            _vm._v(" "),
            _c("span", { staticClass: "text-muted ml-2" }, [
              _vm._v("Reading pages…")
            ])
          ],
          1
        )
      : _c(
          "div",
          [
            _c("p", { staticClass: "text-muted" }, [
              _vm._v(
                "\n      This PDF has " +
                  _vm._s(_vm.pageCount) +
                  " page" +
                  _vm._s(_vm.pageCount === 1 ? "" : "s") +
                  ". Choose which page(s) Lasso should read — leave out\n      cover pages, instructions, or other pages that aren't part of the RFI.\n    "
              )
            ]),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "mb-2",
                attrs: { label: "Pages", "label-class": "font-weight-bold" }
              },
              [
                _c("b-form-input", {
                  attrs: {
                    size: "sm",
                    placeholder: "e.g. 3-8, 12",
                    state: _vm.rangeValid ? null : false
                  },
                  on: {
                    change: _vm.applyRange,
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.applyRange($event)
                    }
                  },
                  model: {
                    value: _vm.rangeText,
                    callback: function($$v) {
                      _vm.rangeText = $$v
                    },
                    expression: "rangeText"
                  }
                }),
                _vm._v(" "),
                !_vm.rangeValid
                  ? _c("small", { staticClass: "rfi-page-select__err" }, [
                      _vm._v(
                        "\n        Enter page numbers or ranges between 1 and " +
                          _vm._s(_vm.pageCount) +
                          ' (e.g. "3-8, 12").\n      '
                      )
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-alert",
              {
                staticClass: "py-2 small",
                attrs: { show: !!_vm.blockReason, variant: "danger" }
              },
              [_vm._v("\n      " + _vm._s(_vm.blockReason) + "\n    ")]
            ),
            _vm._v(" "),
            _c(
              "b-alert",
              {
                staticClass: "py-2 small",
                attrs: {
                  show: !_vm.blockReason && !!_vm.sizeWarning,
                  variant: "warning"
                }
              },
              [_vm._v("\n      " + _vm._s(_vm.sizeWarning) + "\n    ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rfi-page-select__list" },
              [
                _c(
                  "b-form-checkbox-group",
                  {
                    attrs: { stacked: "" },
                    model: {
                      value: _vm.selected,
                      callback: function($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected"
                    }
                  },
                  _vm._l(_vm.pageCount, function(n) {
                    return _c(
                      "b-form-checkbox",
                      {
                        key: n,
                        staticClass: "rfi-page-select__item",
                        attrs: { value: n }
                      },
                      [_vm._v("\n          Page " + _vm._s(n) + "\n        ")]
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center mt-3"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "pl-0",
                        attrs: { variant: "link", size: "sm" },
                        on: { click: _vm.toggleAll }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.allSelected ? "Clear all" : "Select all"
                            ) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-muted small ml-2" }, [
                      _vm._v(
                        _vm._s(_vm.selected.length) +
                          " of " +
                          _vm._s(_vm.pageCount) +
                          " selected"
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-2",
                        attrs: { variant: "light" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("cancel")
                          }
                        }
                      },
                      [_vm._v("\n          Cancel\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "primary",
                          disabled: !_vm.selected.length || !!_vm.blockReason
                        },
                        on: { click: _vm.confirm }
                      },
                      [_vm._v("\n          Continue\n        ")]
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }